import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { OpenSupportTicketDialogPayload } from '../../@core/models/model';

@Injectable({
    providedIn: 'root'
})
export class SupportTicketDialogService {
    private openDialogSubject = new Subject<OpenSupportTicketDialogPayload>();

    openDialog$ = this.openDialogSubject.asObservable();

    openDialog(payload?: OpenSupportTicketDialogPayload): void {
        this.openDialogSubject.next(payload || {});
    }
}

